import { createDictionary } from './_base-dictionary'
export default createDictionary({
  resource: 'data/regions'
})
